export default async function(to?: { fullPath: string }) {
  const { $i18n } = useNuxtApp();

  const route = to || useRoute();

  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');

  return await navigateTo(`/${$i18n.locale.value}/login?redirect=${encodeURIComponent(route.fullPath)}`, { redirectCode: 301 });
}
